import { render } from "./Actions.vue?vue&type=template&id=1f13f40b&scoped=true&ts=true"
import script from "./Actions.vue?vue&type=script&lang=ts"
export * from "./Actions.vue?vue&type=script&lang=ts"

import "./Actions.vue?vue&type=style&index=0&id=1f13f40b&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f13f40b"]])

export default __exports__